export default __webpack_public_path__ + "static/media/early-sketches-2.2bb93b2c.png";